import { SubscriptionPaymentMethod } from '@houzy/schemas/partner-management/partner-subscription-management';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import type { ReactElement } from 'react';

export const PAYMENT_METHOD_PRESENTATION: Record<SubscriptionPaymentMethod, { icon: ReactElement; copy: string }> = {
    [SubscriptionPaymentMethod.Card]: { icon: <CreditCardIcon />, copy: 'CARD' },
    [SubscriptionPaymentMethod.Twint]: { icon: <SmartphoneOutlinedIcon />, copy: 'TWINT' },
    [SubscriptionPaymentMethod.Invoice]: { icon: <ReceiptLongOutlinedIcon />, copy: 'INVOICE' },
};
